import React from 'react';
import PropTypes from 'prop-types';

const IntroductionButton = ({ color }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40px"
      height="40px"
      viewBox="0 0 1000 1000"
      fill={color}
      role="img"
    >
      <title>Read about me3</title>
      <g id="Group_294" transform="translate(-2.5 -18.2)">
        <g id="Group_293" transform="translate(2.5 18.2)">
          <path
            id="Path_517"
            d="M977.88,222.27h-88.3v-54.69c-0.04-11.6-9.43-20.99-21.03-21.03c-127.01,0.13-252.76,25.14-370.15,73.62
       c-117.2-49.07-243.06-74.1-370.12-73.62c-11.6,0.04-20.99,9.43-21.03,21.03v54.69H21.03C9.43,222.31,0.04,231.71,0,243.31v552.03
       c0.04,11.6,9.43,20.99,21.03,21.03h957.94c11.6-0.04,20.99-9.43,21.03-21.03v-553.1C998.65,231,989.21,222.47,977.88,222.27z
        M520.5,764.84V256.97c104.59-42.91,216.11-66.41,329.12-69.37v511.01C736.85,700.9,625.38,723.33,520.5,764.84z M150.38,187.6
       c112.67,2.96,223.86,26.48,328.09,69.39v507.85C373.54,723.43,262.09,701,149.31,698.61V187.6H150.38z M41.05,263.27h68.31v456.35
       c0.04,11.6,9.43,20.99,21.03,21.03c83.21,0.4,165.99,12.07,246.06,34.7H41.05V263.27z M957.94,774.33H622.51
       c80.08-22.63,162.85-34.3,246.06-34.7c11.6-0.04,20.99-9.43,21.03-21.03V263.27h68.36L957.94,774.33z"
          />
          <path
            id="Path_518"
            d="M227.13,319c55.97,5.94,111.25,17.21,165.08,33.66c1.98,0.86,4.15,1.22,6.3,1.06
       c9-0.49,16.84-6.28,19.97-14.73c3.02-10.72-3.04-21.9-13.67-25.23c-56.33-16.66-114.04-28.24-172.45-34.6
       c-11.14-0.82-21.11,6.88-23.13,17.87C208.53,307.91,216.34,317.49,227.13,319z"
          />
          <path
            id="Path_519"
            d="M404.94,412.59c-56.37-16.66-114.13-28.24-172.57-34.58c-11.33-1.45-21.7,6.56-23.16,17.89
       c-1.45,11.33,6.56,21.7,17.89,23.16l0,0c55.97,5.94,111.25,17.21,165.08,33.66c1.98,0.86,4.15,1.22,6.3,1.06
       c11.6,0,21.01-9.4,21.01-21c0-9.18-5.95-17.3-14.71-20.05L404.94,412.59z"
          />
          <path
            id="Path_520"
            d="M404.94,512.48c-56.37-16.66-114.13-28.24-172.57-34.58c-11.33-1.45-21.7,6.56-23.16,17.89
       c-1.45,11.33,6.56,21.7,17.89,23.16l0,0c55.97,5.94,111.25,17.21,165.08,33.66c1.98,0.86,4.15,1.22,6.3,1.06
       c11.6,0,21.01-9.4,21.01-21c0-9.18-5.95-17.3-14.71-20.05L404.94,512.48z"
          />
          <path
            id="Path_521"
            d="M404.94,611.33c-56.37-16.66-114.13-28.24-172.57-34.58c-11.33-1.45-21.7,6.56-23.16,17.89
       c-1.45,11.33,6.56,21.7,17.89,23.16l0,0c55.97,5.94,111.25,17.21,165.08,33.66c1.98,0.86,4.15,1.22,6.3,1.06
       c11.6,0,21.01-9.4,21.01-21c0-9.18-5.95-17.3-14.71-20.05L404.94,611.33z"
          />
          <path
            id="Path_522"
            d="M766.56,278.12c-58.4,6.39-116.12,18-172.45,34.7c-10.63,3.33-16.68,14.51-13.67,25.23
       c2.86,8.64,10.86,14.55,19.97,14.73c2.16,0.16,4.32-0.2,6.3-1.06c54.01-15.74,109.22-27,165.08-33.66
       c10.87-0.87,18.98-10.4,18.11-21.27c-0.05-0.62-0.13-1.25-0.24-1.86C787.44,284.22,777.44,276.95,766.56,278.12z"
          />
          <path
            id="Path_523"
            d="M766.56,377.89c-58.42,6.29-116.14,17.9-172.45,34.7c-10.63,3.33-16.68,14.51-13.67,25.23
       c2.86,8.64,10.86,14.55,19.97,14.73c2.16,0.16,4.32-0.2,6.3-1.06c53.96-15.95,109.19-27.21,165.08-33.66
       c11.08-1.13,19.14-11.03,18.01-22.11c-1.13-11.08-11.03-19.14-22.11-18.01c-0.39,0.04-0.78,0.09-1.16,0.15L766.56,377.89z"
          />
          <path
            id="Path_524"
            d="M766.56,476.84c-58.45,6.65-116.17,18.61-172.45,35.76c-10.63,3.33-16.68,14.51-13.67,25.23
       c2.86,8.64,10.86,14.55,19.97,14.73c2.16,0.16,4.32-0.2,6.3-1.06c53.96-15.95,109.19-27.21,165.08-33.66
       c10.87-0.87,18.98-10.4,18.11-21.27c-0.05-0.62-0.13-1.25-0.24-1.86C787.95,483.55,777.79,475.69,766.56,476.84z"
          />
          <path
            id="Path_525"
            d="M766.56,576.75c-58.42,6.29-116.14,17.9-172.45,34.7c-10.63,3.33-16.68,14.51-13.67,25.23
       c2.86,8.64,10.86,14.55,19.97,14.73c2.16,0.16,4.32-0.2,6.3-1.06c53.96-15.95,109.19-27.21,165.08-33.66
       c10.87-0.87,18.98-10.4,18.11-21.27c-0.05-0.62-0.13-1.25-0.24-1.86C787.44,582.85,777.44,575.58,766.56,576.75z"
          />
        </g>
      </g>
    </svg>
  );
};

export default IntroductionButton;

IntroductionButton.propTypes = {
  color: PropTypes.string.isRequired,
};
